// Municipality.js

import React, { useState } from "react";
import GridLayout from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import "./Home.css"; // reuse same styles
import { Responsive, WidthProvider } from "react-grid-layout";
import { useParams, useNavigate } from "react-router-dom";
import municipalityData from "./municipalityData";
import Modal from "./Modal";


const ResponsiveGridLayout = WidthProvider(Responsive);

// Example municipalities data by county
const municipalitiesByCounty = {
    Adams: [
      "Abbottstown Borough",
      "Arendtsville Borough",
      "Bendersville Borough",
      "Berwick Township",
      "Biglerville Borough",
      "Bonneauville Borough",
      "Butler Township",
      "Carroll Valley Borough",
      "Conewago Township",
      "Cumberland Township",
      "East Berlin Borough",
      "Fairfield Borough",
      "Franklin Township",
      "Freedom Township",
      "Germany Township",
      "Gettysburg Borough",
      "Hamilton Township",
      "Hamiltonban Township",
      "Highland Township",
      "Huntington Township",
      "Latimore Township",
      "Liberty Township",
      "Littlestown Borough",
      "McSherrystown Borough",
      "Menallen Township",
      "Mt. Joy Township",
      "Mt. Pleasant Township",
      "Oxford Township",
      "Reading Township",
      "Straban Township",
      "Tyrone Township",
      "York Springs Borough"
    ],

    Berks: [
        "Albany Township",
        "Alsace Township",
        "Amity Township",
        "Bally Borough",
        "Bechtelsville Borough",
        "Bern Township",
        "Bernville Borough",
        "Bethel Township",
        "Birdsboro Borough",
        "Boyertown Borough",
        "Brecknock Township",
        "Caernarvon Township",
        "Centerport Borough",
        "Centre Township",
        "Colebrookdale Township",
        "Cumru Township",
        "District Township",
        "Douglass Township",
        "Earl Township",
        "Exeter Township",
        "Fleetwood Borough",
        "Greenwich Township",
        "Hamburg Borough",
        "Heidelberg Township",
        "Hereford Township",
        "Jefferson Township",
        "Kenhorst Borough",
        "Kutztown Borough",
        "Laureldale Borough",
        "Leesport Borough",
        "Lenhartsville Borough",
        "Longswamp Township",
        "Lower Alsace Township",
        "Lower Heidelberg Twp.",
        "Lyons Borough",
        "Maidencreek Township",
        "Marion Township",
        "Maxatawny Township",
        "Mohnton Borough",
        "Mt. Penn Borough",
        "Muhlenberg Township",
        "New Morgan Borough",
        "North Heidelberg Twp.",
        "Oley Township",
        "Ontelaunee Township",
        "Penn Township",
        "Perry Township",
        "Pike Township",
        "City of Reading",
        "Richmond Township",
        "Robeson Township",
        "Robesonia Borough",
        "Rockland Township",
        "Ruscombmanor Township",
        "Shillington Borough",
        "Shoemakersville Borough",
        "Sinking Spring",
        "South Heidelberg Twp.",
        "Spring Township",
        "St. Lawrence Borough",
        "Tilden Township",
        "Topton Borough",
        "Tulpehocken Township",
        "Union Township",
        "Upper Bern Township",
        "Upper Tulpehocken Twp.",
        "Washington Township",
        "Wernersville Borough",
        "West Reading Borough",
        "Windsor Township",
        "Womelsdorf Borough",
        "Wyomissing Borough"
    ],
    Cumberland: [
        "Camp Hill Borough",
        "Carlisle Borough",
        "Cooke Township",
        "Dickinson Township",
        "East Pennsboro Township",
        "Hampden Township",
        "Hopewell Township",
        "Lemoyne Borough",
        "Lower Allen Township",
        "Lower Frankford Township",
       // "Lower Mifflin Township",
        "Mechanicsburg Borough",
        "Middlesex Township",
        "Monroe Township",
        "Mt. Holly Springs Borough",
        "New Cumberland Borough",
        "Newburg Borough",
        "Newville Borough",
        "North Middleton Township",
        "North Newton Township",
        "Penn Township",
        "Shippensburg Borough",
        "Shippensburg Township",
        "Shiremanstown Borough",
        "Silver Spring Township",
        "South Middleton Township",
        "South Newton Township",
        "Southampton Township",
        "Upper Allen Township",
        "Upper Frankford Township",
        "Upper Mifflin Township",
        "West Pennsboro Township",
        "Wormleysburg Borough"
    ],
    Dauphin: [
      "Berrysburg Borough",
      "Conewago Township",
      "Dauphin Borough",
      "Derry Township",
      "East Hanover Township",
      "Elizabethville Borough",
      "Elizabethtown Borough",
      "Gratz Borough",
      "Halifax Borough",
      "Halifax Township",
      "Harrisburg City",
      "Highspire Borough",
      "Hummelstown Borough",
      "Jackson Township",
      "Jefferson Township",
      "Londonderry Township",
      "Lower Paxton Township",
      "Lower Swatara Township",
      "Lykens Borough",
      "Lykens Township",
      "Middle Paxton Township",
      "Middletown Borough",
      "Mifflin Township",
      "Millersburg Borough",
      "Paxtang Borough",
      "Penbrook Borough",
      "Pillow Borough",
      "Reed Township",
      "Royalton Borough",
      "Rush Township",
      "South Hanover Township",
      "Steelton Borough",
      "Susquehanna Township",
      "Swatara Township",
      "Upper Paxton Township",
      "Washington Township",
      "Wayne Township",
      "West Hanover Township",
      "Wiconisco Township",
      "Williams Township",
      "Williamstown Borough"
  ],
    Juniata: [
        "Beale Township",
        "Delaware Township",
        "Fayette Township",
        "Fermanagh Township",
        "Greenwood Township",
        "Lack Township",
        "Mifflin Borough",
        "Mifflintown Borough",
        "Milford Township",
        "Monroe Township",
        "Port Royal Borough",
        "Spruce Hill Township",
        "Susquehanna Township",
        "Thompsontown Borough",
        "Turbett Township",
        "Tuscarora Township",
        "Walker Township"
    ],
    Lancaster: [
        "Adamstown Borough",
        "Akron Borough",
        "Bart Township",
        "Brecknock Township",
        "Caernarvon Township",
        "Christiana Borough",
        "Clay Township",
        "Colerain Township",
        "Columbia Borough",
        "Conestoga Township",
        "Conoy Township",
        "Denver Borough",
        "Drumore Township",
        "Earl Township",
        "East Cocalico Township",
        "East Donegal Township",
        "East Drumore Township",
        "East Earl Township",
        "East Hempfield Township",
        "East Lampeter Township",
        "East Petersburg Borough",
        "Eden Township",
        "Elizabeth Township",
        "Elizabethtown Borough",
        "Ephrata Borough",
        "Ephrata Township",
        "Fulton Township",
        "Lancaster City",
        "Lancaster Township",
        "Leacock Township",
        "Lititz Borough",
        "Little Britain Township",
        "Manheim Borough",
        "Manheim Township",
        "Manor Township",
        "Marietta Borough",
        "Martic Township",
        "Millersville Borough",
        "Mount Joy Borough",
        "Mount Joy Township",
        "Mountville Borough",
        "New Holland Borough",
        "Paradise Township",
        "Penn Township",
        "Pequea Township",
        "Providence Township",
        "Quarryville Borough",
        "Rapho Township",
        "Sadsbury Township",
        "Salisbury Township",
        "Strasburg Borough",
        "Strasburg Township",
        "Terre Hill Borough",
        "Upper Leacock Township",
        "Warwick Township",
        "West Cocalico Township",
        "West Donegal Township",
        "West Earl Township",
        "West Hempfield Township",
        "West Lampeter Township"
    ],
    Lebanon: [
        "Annville Township",
        "Bethel Township",
        "Cleona Borough",
        "Cornwall Borough",
        "East Hanover Township",
        "Heidelberg Township",
        "Jackson Township",
        "Jonestown Borough",
        "Lebanon City",
        "Millcreek Township",
        "Mount Gretna Borough",
        "Myerstown Borough",
        "North Annville Township",
        "North Cornwall Township",
        "North Lebanon Township",
        "North Londonderry Township",
        "Palmyra Borough",
        "Richland Borough",
        "South Annville Township",
        "South Lebanon Township",
        "South Londonderry Township",
        "Swatara Township",
        "Union Township",
        "West Cornwall Township",
        "West Lebanon Township"
    ],
    Mifflin: [
        "Armagh Township",
        "Bratton Township",
        "Brown Township",
        "Burnham Borough",
        "Decatur Township",
        "Derry Township",
        "Granville Township",
        "Juniata Terrace Borough",
        "Kistler Borough",
        "Lewistown Borough",
        "McVeytown Borough",
        "Menno Township",
        "Newton Hamilton Borough",
        "Oliver Township",
        "Union Township",
        "Wayne Township"
    ],
    Northumberland: [
        "Coal Township",
        "Delaware Township",
        "East Cameron Township",
        "East Chillisquaque Township",
        "Herndon Borough",
        "Jackson Township",
        "Jordan Township",
        "Kulpmont Borough",
        "Lewis Township",
        "Little Mahanoy Township",
        "Lower Augusta Township",
        "Lower Mahanoy Township",
        "Marion Heights Borough",
        "McEwensville Borough",
        "Milton Borough",
        "Mount Carmel Borough",
        "Mount Carmel Township",
        "Northumberland Borough",
        "Point Township",
        "Ralpho Township",
        "Riverside Borough",
        "Rockefeller Township",
        "Rush Township",
        "City of Shamokin",
        "Shamokin Township",
        "Snydertown Borough",
        "City of Sunbury",
        "Turbot Township",
        "Turbotville Borough",
        "Upper Augusta Township",
        "Upper Mahanoy Township",
        "Washington Township",
        "Watsontown Borough",
        "West Cameron Township",
        "West Chillisquaque Township",
        "Zerbe Township"
    ],
    Perry: [
        "Blain Borough",
        "Bloomfield Borough",
        "Buffalo Township",
        "Carroll Township",
        "Centre Township",
        "Duncannon Borough",
        "Greenwood Township",
        "Howe Township",
        "Jackson Township",
       // "Juniata Township",
       // "Landisburg Borough",
        "Liverpool Borough",
        "Liverpool Township",
        "Marysville Borough",
       // "Miller Township",
        "Millerstown Borough",
        "New Buffalo Borough",
        "Newport Borough",
       // "Northeast Madison Township",
       // "Oliver Township",
        "Penn Township",
        "Rye Township",
       // "Saville Township",
       // "Southwest Madison Township",
       // "Spring Township",
       // "Toboyne Township",
       // "Tuscarora Township",
       // "Tyrone Township",
       // "Watts Township",
       // "Wheatfield Township"
    ],
    Schuylkill: [
        "Ashland Borough",
        "Auburn Borough",
        "Barry Township",
        "Blythe Township",
        "Branch Township",
        "Butler Township",
        "Cass Township",
        "Coaldale Borough",
        "Cressona Borough",
        "Deer Lake Borough",
        "Delano Township",
        "East Brunswick Township",
        "East Norwegian Township",
        "East Union Township",
        "Eldred Township",
        "Frackville Borough",
        "Frailey Township",
        "Gilberton Borough",
        "Girardville Borough",
        "Gordon Borough",
        "Hegins Township",
        "Hubley Township",
        "Landingville Borough",
        "Mahanoy City Borough",
        "Mahanoy Township",
        "McAdoo Borough",
        "Mechanicsville Borough",
        "Middleport Borough",
        "Minersville Borough",
        "Mount Carbon Borough",
        "New Castle Township",
        "New Philadelphia Borough",
        "New Ringgold Borough",
        "North Manheim Township",
        "North Union Township",
        "Norwegian Township",
        "Orwigsburg Borough",
        "Palo Alto Borough",
        "Pine Grove Borough",
        "Pine Grove Township",
        "Port Carbon Borough",
        "Port Clinton Borough",
        "Porter Township",
        "City of Pottsville", // County seat
        "Reilly Township",
        "Ringtown Borough",
        "Rush Township",
        "Ryan Township",
        "Schuylkill Haven Borough",
        "Schuylkill Township",
        "Shenandoah Borough",
        "South Manheim Township",
        "St Clair Borough",
        "Tamaqua Borough",
        "Tower City Borough",
        "Tremont Borough",
        "Tremont Township",
        "Union Township",
        "Upper Mahantango Township",
        "Walker Township",
        "Washington Township",
        "Wayne Township",
        "West Brunswick Township",
        "West Mahanoy Township",
        "West Penn Township"
    ],
    Snyder: [
        "Adams Township",
        "Beaver Township",
        "Beavertown Borough",
        "Center Township",
        "Chapman Township",
        "Franklin Township",
        "Freeburg Borough",
        "Jackson Township",
        "McClure Borough",
        "Middleburg Borough", // County seat
        "Middlecreek Township",
        "Monroe Township",
        "Penn Township",
        "Perry Township",
        "Selinsgrove Borough",
        "Shamokin Dam Borough",
        "Spring Township",
        "Union Township",
        "Washington Township",
        "West Beaver Township",
        "West Perry Township",
    ],
    York: [
        "Carroll Township",
        "Chanceford Township",
        "Codorus Township",
        "Conewago Township",
        "Cross Roads Borough",
        "Dallastown Borough",
        "Delta Borough",
        "Dillsburg Borough",
        "Dover Borough",
        "Dover Township",
        "East Hopewell Township",
        "East Manchester Township",
        "East Prospect Borough",
        "Fairview Township",
        "Fawn Grove Borough",
        "Fawn Township",
        "Felton Borough",
        "Franklin Township",
        "Franklintown Borough",
        "Glen Rock Borough",
        "Goldsboro Borough",
        "Hallam Borough",
        "Hanover Borough",
        "Heidelberg Township",
        "Hellam Township",
        "Hopewell Township",
        "Jackson Township",
        "Jacobus Borough",
        "Jefferson Borough",
        "Lewisberry Borough",
        "Loganville Borough",
        "Lower Chanceford Township",
        "Lower Windsor Township",
        "Manchester Borough",
        "Manchester Township",
        "Manheim Township",
        "Monaghan Township",
        "Mt Wolf Borough",
        "New Freedom Borough",
        "New Salem Borough",
        "Newberry Township",
        "North Codorus Township",
        "North Hopewell Township",
        "North York Borough",
        "Paradise Township",
        "Peach Bottom Township",
        "Penn Township",
        "Railroad Borough",
        "Red Lion Borough",
        "Seven Valleys Borough",
        "Shrewsbury Borough",
        "Shrewsbury Township",
        "Spring Garden Township",
        "Spring Grove Borough",
        "Springettsbury Township",
        "Springfield Township",
        "Stewartstown Borough",
        "Warrington Township",
        "Washington Township",
        "Wellsville Borough",
        "West Manchester Township",
        "West Manheim Township",
        "West York Borough",
        "Windsor Borough",
        "Windsor Township",
        "Winterstown Borough",
        "Wrightsville Borough",
        "Yoe Borough",
        "City of York",
        "York Haven Borough",
        "York Township",
        "Yorkana Borough"
    ]
    };

export default function Municipality() {
  const { countyKey } = useParams(); 
  const navigate = useNavigate();

  // Fallback if countyKey doesn't exist
  const municipalityNames = municipalitiesByCounty[countyKey] || [];

  // Create widget objects for these municipalities
  const widgets = municipalityNames.map((name, idx) => ({
    key: `${countyKey}_muni_${idx}`,
    title: name,
    url: `/municipality/${countyKey}/${encodeURIComponent(name)}`  // you can choose route format
  }));

  // Layout config: positions for large screens
  const layoutLg = widgets.map((widget, idx) => {
    const col = idx % 4;
    const row = Math.floor(idx / 3);
    return {
      i: widget.key,
      x: col,
      y: row,
      w: 1,
      h: 1,
    };
  });

  // For small screens, stack vertically
  const layoutSm = layoutLg.map(item => ({
    ...item,
    x: 0,
    w: 1,
  }));

  const breakpoints = { lg: 520, sm: 0 };
  const cols = { lg: 4, sm: 1 };
  const layouts = {
    lg: layoutLg,
    sm: layoutSm,
  };

  const [selectedMuni, setSelectedMuni] = useState(null);
  const [selectedCounty, setSelectedCounty] = useState(null);


  return (
    <div className="home-container-munc">
      <div className="grid-wrapper">
        <ResponsiveGridLayout
          className="layout"
          layouts={layouts}
          breakpoints={breakpoints}
          cols={cols}
          rowHeight={150}
          isResizable={false}
          isDraggable={false}
        >
          {widgets.map(widget => (
            <div
              key={widget.key}
              className="widget-card1"
              onClick={() => {
                setSelectedMuni(widget.title);
                setSelectedCounty(countyKey); // <-- set the county here
              }}
            >
              <span className="munc-title-text">{widget.title}</span> 
            </div>
          ))}
        </ResponsiveGridLayout>
      </div>
      {/* 🔹 Modal Popup */}
      {/* 🔹 Use Modal component */}
    <Modal isOpen={!!selectedMuni} onClose={() => setSelectedMuni(null)}>
      <h2>{selectedMuni}</h2>
      {municipalityData[countyKey] && municipalityData[countyKey][selectedMuni] ? (
        <ul>
          {Object.entries(municipalityData[countyKey][selectedMuni]).map(
            ([key, value]) => (
              <li key={key}>
                <strong>{key}:</strong> {value}
              </li>
            )
          )}
        </ul>
      ) : (
        <p>No data available for this municipality.</p>
      )}
      <button onClick={() => setSelectedMuni(null)}>Close</button>
    </Modal>
    </div>
  );
}
